"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StringDropdownModel = void 0;
const tslib_1 = require("tslib");
const UngroupedDropdownWidget_1 = tslib_1.__importDefault(require("./UngroupedDropdownWidget"));
class StringDropdownModel {
    constructor(shouldSelectIfSingleOption = true, noOptionText) {
        this.shouldSelectIfSingleOption = shouldSelectIfSingleOption;
        this.noOptionText = noOptionText;
    }
    formatItem(item) {
        return item;
    }
    isEqual(a, b) {
        return a === b;
    }
    selectIfSingleOption() {
        return this.shouldSelectIfSingleOption;
    }
    getTextForNoOptionSelected() {
        return this.noOptionText === null ? null : this.noOptionText ?? "Vælg";
    }
}
exports.StringDropdownModel = StringDropdownModel;
class WCAGStringUngroupedDropdown extends UngroupedDropdownWidget_1.default {
    constructor(args) {
        super({
            ...args,
            model: new StringDropdownModel(args.shouldSelectIfSingleOption, args.noOptionText)
        });
    }
    decorateUngroupedDropdownElement(args) {
        const dropdownElement = this.element;
        this.element = document.createElement("div");
        this.element.classList.add("string-dropdown");
        this.add(this.labelElement);
        this.add(dropdownElement);
        this.add(this.hintElement);
    }
    ;
}
exports.default = WCAGStringUngroupedDropdown;
//# sourceMappingURL=WCAGStringUngroupedDropdown.js.map